export const ERROR_MESSAGES: {[key: number]:string} = {
	0: "Errore generico, contattare l'amministratore del sistema",
	401: 'Utente non autorizzato',
	403: "Non è permesso chiamare le API. Contattare l'amministratore del sistema",
	404: "Problema nella chiamata al server. Contattare l'amministratore del sistema",
	500: "Problema sul server. Contattare l'amministratore del sistema"
};